import { render, staticRenderFns } from "./ln-form-addon-radio.vue?vue&type=template&id=4db663d6&"
import script from "./ln-form-addon-radio.vue?vue&type=script&lang=js&"
export * from "./ln-form-addon-radio.vue?vue&type=script&lang=js&"
import style0 from "./ln-form-addon-radio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports